(function () {
  Flint.file('devbar.js', function (require) {
    var avg = function avg(xs) {
      var sum = 0;
      if (xs.length === 0) return 0;
      for (var i = 0; i < xs.length; i++) {
        sum += parseInt(xs[i], 10);
      }
      return sum / xs.length;
    };

    Flint.staticStyles('DevBar', {
      '$bar': '#_flintdevtools bar.DevBar, #_flintdevtools .DevBar.bar, #_flintdevtools .ViewDevBar.bar, #_flintdevtools .DevBar > .bar',
      '$pin': '#_flintdevtools pin.DevBar, #_flintdevtools .DevBar.pin, #_flintdevtools .ViewDevBar.pin, #_flintdevtools .DevBar > .pin',
      '$label': '#_flintdevtools label.DevBar, #_flintdevtools .DevBar.label, #_flintdevtools .ViewDevBar.label, #_flintdevtools .DevBar > .label',
      '$fps': '#_flintdevtools fps.DevBar, #_flintdevtools .DevBar.fps, #_flintdevtools .ViewDevBar.fps, #_flintdevtools .DevBar > .fps',
      '$button': '#_flintdevtools button.DevBar, #_flintdevtools .DevBar.button, #_flintdevtools .ViewDevBar.button, #_flintdevtools .DevBar > .button'
    }, {
      '$bar': {
        flexFlow: 'row',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'white',
        height: 50,
        border: [1, 'solid', '#ccc'],
        padding: [10, 15],
        pointerEvents: 'all'
      },
      '$pin': {
        position: 'absolute',
        right: 10,
        top: 3
      },
      '$label': {
        flexFlow: 'row',
        fontSize: 15,
        marginTop: 1,
        fontWeight: 'bold'
      },
      '$fps': {
        flexFlow: 'row'
      },
      '$button': {
        marginLeft: 20
      }
    });
    Flint.view('DevBar', function (view, on, $) {
      var fps = 0;
      var hud = false;
      var times = [];
      var avgTime = 0;

      var pinned = localStorage.getItem('devbar') === 'true';

      var setAvg = function setAvg() {
        console.log('times are', times, 'avg is', avg(times));
        view.set('avgTime', avgTime = avg(times));
        view.set('fps', fps = avgTime === 0 ? 0 : 1000 / avgTime);
        view.updateSoft();
      };

      on.event('hot:finished', function (_ref) {
        var time = _ref.time;

        if (pinned) {
          view.set('times', times.push(time), times, true);
          setAvg();
        }
        view.updateSoft();
      });

      var togglePin = function togglePin() {}
      // localStorage.setItem('devbar', pinned)

      //on.event('hud:show', () => hud = true)
      //on.event('hud:hide', () => hud = false)

      ;view.render(function () {
        return Flint.iff(hud || pinned) && view.el(
          ['bar', 1],
          { if: hud || pinned },
          view.el(
            ['fps', 1],
            null,
            view.el(
              ['label', 1],
              null,
              'Live: ',
              ('' + fps).substr(0, 6),
              ' FPS'
            ),
            view.el(
              ['button', 1],
              { onClick: function () {
                  view.set('times', times = []);setAvg();view.updateSoft();
                } },
              'reset'
            )
          )
        );
      });
    });
  })
})();

/*<pin onClick={togglePin }>Pin</pin>*/
//# sourceMappingURL=devbar.js.map
